import React from 'react';

import { COLORS } from '../../config/designSystem/Colors';
import { Caption1Bold } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';
import { StyleProp, TouchableOpacity,ViewStyle } from 'react-native';


interface ButtonProps {
  onPress: () => void;
  label: string;
  style?: StyleProp<ViewStyle>;
  /** greyed out, not pressable: explains why there is nothing to do (e.g. "already completed today") */
  disabled?: boolean;
}

const DesignSystemButton = ({ label, onPress, style, disabled = false }: ButtonProps) => {

  return (
    <TouchableOpacity
      style={[
        {
          backgroundColor: disabled ? COLORS.border.secondary : COLORS.content.accent,
          paddingVertical: SPACING['sp-12'],
          paddingHorizontal: SPACING['sp-24'],
          borderRadius: SPACING['sp-24'],
          width:'100%',
          alignItems:'center'
        },
        style
      ]}
      onPress={onPress}
      disabled={disabled}
      accessibilityState={{ disabled }}
    >

      <Caption1Bold color={disabled ? COLORS.content.secondary : COLORS.content['inverse-primary']}>{label}</Caption1Bold>
    </TouchableOpacity>
  );
};

export default DesignSystemButton;
